import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import { Divider, Drawer, IconButton, List } from '@mui/material';
import { FC, useState } from 'react';
import { DrawerHeader } from '../drawerHeader';
import { NavItem, MenuItem } from './item';

type Props = {
  config: Array<MenuItem>;
};

export const SmallScreenMenu: FC<Props> = ({ config }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        edge="start"
        disableRipple
        sx={{
          mr: 2,
          display: {
            xs: 'flex',
            md: 'none'
          },
          '&:hover svg': {
            color: 'grey.900'
          }
        }}
      >
        <MenuIcon color="primary" />
      </IconButton>
      <Drawer
        sx={{
          width: '100%',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: '100%',
            boxSizing: 'border-box',
            backgroundColor: '#121828'
          },
          display: {
            md: 'none'
          }
        }}
        anchor="top"
        open={open}
        onClose={() => setOpen(false)}
      >
        <DrawerHeader>
          <IconButton
            sx={{
              color: '#D1D5DB'
            }}
            onClick={() => setOpen(false)}
          >
            <ChevronLeftIcon />
          </IconButton>
        </DrawerHeader>
        <Divider color={'#2D3748'} />
        <List onClick={() => setOpen(false)}>
          {config.map((item) => (
            <NavItem key={item.route} {...item} />
          ))}
        </List>
      </Drawer>
    </>
  );
};
